import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import React, { Component } from 'react';

export class EditableDropdown extends Component
{
   constructor(props) {
		super(props);
        //inputId
        //items [{label,value}]
        //label
        //onChange(inputId,value)
    }
    onChange=(e)=>
    {
        if(this.props.onChange)
            this.props.onChange(e);
    }
    render()
	{
		return(            
                    <div className="p-inputgroup flex-1">
                        <Dropdown inputId={this.props.inputId} id={this.props.inputId} value={this.props.value} options={this.props.options} 
                        optionLabel={this.props.optionLabel} //prime bug option label should be set
                        valueTemplate={this.props.valueTemplate} itemTemplate={this.props.itemTemplate} className="w-12rem"
                        onChange={this.onChange} optionValue={this.props.optionValue}
                        ></Dropdown>
                        <Button onClick={this.props.onAdd}>+ ADD</Button>   
                    </div>
        );
	}
}
export default EditableDropdown;